var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.2223 13.3939C6.69409 13.7708 7.3171 14 8.00008 14C8.68306 14 9.30608 13.7708 9.77786 13.3939M3.00517 11.4545C2.7241 11.4545 2.56711 11.013 2.73713 10.7676C3.13165 10.1984 3.51245 9.36343 3.51245 8.35799L3.52872 6.90111C3.52872 4.1943 5.53062 2 8.00008 2C10.5059 2 12.5373 4.22662 12.5373 6.9733L12.521 8.35799C12.521 9.37034 12.8887 10.2098 13.2672 10.7793C13.4306 11.0253 13.2732 11.4545 12.9956 11.4545H3.00517Z",
    stroke: "current",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.02143a07e2299b4ef075ad7b99310b6c.svg";
export { ForwardRef as ReactComponent };